export default __webpack_public_path__ + "static/media/BM_RenderCamera_10_BedroomB+Interior+Light_Scheme+Bedroom.0eff2ed6.jpg";